import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

const Frame = styled.div`
  display: flex;
  padding-left: 10px;
  align-items: center;
  gap: 8px;
`

const Box = styled.div`
  display: flex;
  width: 72px;
  height: 64px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  background: var(--green10, #f4fcfa);
`
const PlayerBox = styled.div`
  color: var(--green100, #57c9a7);
  font-family: SUIT;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`

const ValueBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
`
const ValueText = styled.div`
  color: var(--gray90, #333);
  font-family: SUIT;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`

const Line = styled.div`
  width: 32px;
  height: 1px;
  background: var(--gray50, #b3b3b3);
`
const Colon = styled.div`
  color: var(--gray90, #333);
  font-family: SUIT;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`
const InputFrame = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

const Input = styled.input`
  width: 50px;
  height: 20px;
  font-size: 20px;
  border: none;
  outline: none;
  background: none;
  text-align: center;
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`

interface RatioProps {
  player1?: string
  player2?: string
  value?: number
  setData?: any
  keyName: string
  onValueChange?: (value: number) => void
}

const Ratio = (props: RatioProps) => {
  const {
    player1 = '-',
    player2 = '-',
    value,
    setData,
    keyName,
    onValueChange,
  } = props
  const [value1, setValue1] = useState(value || 0)
  const parsedValue1 = isNaN(value1) ? '0' : value1.toString()

  useEffect(() => {
    setValue1(value || 0)
  }, [value])

  useEffect(() => {
    setData((prevData: any) => {
      return {
        ...prevData,
        [keyName]: value1,
      }
    })
  }, [keyName, setData, value1])

  const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let newValue = parseFloat(e.target.value)

    if (newValue < 0 || isNaN(newValue)) {
      newValue = 0
    }

    if (newValue > 100) {
      newValue = 100
    }

    setValue1(newValue)
    onValueChange?.(newValue)
  }

  const value2 = 100 - (parsedValue1 !== '' ? parseFloat(parsedValue1) : 0)

  return (
    <Frame>
      <Box>
        <PlayerBox>{player1}</PlayerBox>
        <ValueBox>
          <InputFrame>
            <Input
              type="number"
              value={parsedValue1}
              onChange={handleValueChange}
            />
          </InputFrame>
          <Line />
        </ValueBox>
      </Box>
      <Colon>:</Colon>
      <Box>
        <PlayerBox>{player2}</PlayerBox>
        <ValueBox>
          <ValueText>{isNaN(value2) ? '' : value2}</ValueText>
          <Line />
        </ValueBox>
      </Box>
    </Frame>
  )
}

export default Ratio
